//--------------------------------------------------------------------------
// <copyright file="BackButton.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import backButton from '../images/BackButton.png';

/// <summary>
/// Back button component. This is a wrapper over the back button image.
/// </summary>
const BackButton = ({ onClickFunction }) => {
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickFunction();
    }
  }
  return (
    <img tabIndex="1" src={backButton} className="Dialog-backButton" alt="Back button" onKeyDown={(e) => onKeyDown(e)} onClick={() => onClickFunction()} />
  )
}

export default BackButton